// extracted by mini-css-extract-plugin
module.exports = {"inline":"index__inline___1I3l_"};